const Labour = require("./Labour");
const DailyCleaning = require("./DailyCleaning");
const RegularCleaning = require("./RegularCleaning");
const Food = require("./Food");
const SimulationEvent = require("./SimulationEvent");

const config = {
  inputs: {
    pref: "#pref",
    capacity: "#capacity",
    numberPerRoom: "#numberPerRoom",
    options: "#options"
  },
  submitBtn: "#simulation",
  hiddenInput: "#simulation-result"
}


class Core extends SimulationEvent {
  constructor(config) {
    super();
    this.config = config;
    this.events = {};
    this.costResult = {
      labour: 0,
      food: 0,
      dailyCleaning: 0,
      regularCleaning: 0,
      total: 0
    };
    this.displayResult = {
      min: 0,
      max: 0
    }
    this.listen();
    this.init();

  }

  init() {
    this.findElements();
    if (!this.elements) return;
    this.labour = new Labour(this.elements, this.emit, this.events);
    this.dailyCleaning = new DailyCleaning(this.elements, this.emit, this.events);
    this.regularCleaning = new RegularCleaning(this.elements, this.emit, this.events);
    this.food = new Food(this.elements, this.emit, this.events);
    this.getInitialInputs();
  }

  listen() {
    const events = ["labour", "food", "dailyCleaning", "regularCleaning"];
    for (const event of events) {
      this.on(event, (key, value) => {
        this.costResult = {
          ...this.costResult,
          [key]: value
        }
        this.getSum();
      })
    }
  }

  on(event, cb) {
    this.events = {
      ...this.events,
      [event]: cb
    }
  }

  emit(event, payload) {
    if (event in this.events) {
      this.events[event](event, payload);
    }
  }

  getInitialInputs() {
    const inputValues = super.fetchInputs(this.elements);
    if (!inputValues) return;

    this.labour.setInputs(inputValues);
    this.regularCleaning.setInputs(inputValues);
    this.dailyCleaning.setInputs(inputValues);
    this.food.setInputs(inputValues);

  }

  findElements() {
    const prefEle = document.querySelector(this.config.inputs.pref);
    const capacityEle = document.querySelector(this.config.inputs.capacity);
    const numberPerRoomEle = document.querySelector(this.config.inputs.numberPerRoom);
    const optionsEle = document.querySelector(this.config.inputs.options);
    if (!prefEle || !capacityEle || !numberPerRoomEle || !optionsEle) return;

    this.elements = {
      prefEle,
      capacityEle,
      numberPerRoomEle,
      optionsEle
    }
  }

  getSum() {
    let total = 0;
    for (const cost of Object.keys(this.costResult)) {
      if (cost !== "total") total = total + this.costResult[cost];
    }
    this.costResult = {
      ...this.costResult,
      total
    }

    this.finalizeCost();
  }

  finalizeCost() {
    if (!this.costResult.total) throw new Error("合計金額が所得できません。");

    let finalCost = this.costResult.total / 0.8;
    finalCost = Math.ceil(finalCost / 1000) * 1000;


    const foodSales = this.costResult.food / 626 * 1000;


    // 原価 = 人件費 + 日常清掃 + 定期清掃 + 食材費
    const costPrice = this.costResult.labour + this.costResult.dailyCleaning + this.costResult.regularCleaning + this.costResult.food;

    //概算委託費（原価の83%）
    const delegateCost = Math.ceil((costPrice / 0.83) / 1000) * 1000;

    finalCost = delegateCost;

    //　食事売上を除く処理
    if (this.costResult.food) {
      //　食事売上を除く処理
      const finalCostSales = delegateCost - foodSales
      finalCost = finalCostSales;
    }


    const minNumber = Math.ceil(finalCost * .98 / 5000) * 5000;
    const maxNumber = Math.ceil(finalCost * 1.05 / 5000) * 5000;

    const minNumberConsole = minNumber.toLocaleString('ja-JP', { style: 'currency', currency: 'JPY', minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const maxNumberConsole = maxNumber.toLocaleString('ja-JP', { style: 'currency', currency: 'JPY', minimumFractionDigits: 0, maximumFractionDigits: 0 });


    this.getDisplayResult(finalCost);
  }

  getDisplayResult(price) {
    // 端数を5000円切り上げ
    const min = Math.ceil(price * .98 / 5000) * 5000;
    const max = Math.ceil(price * 1.05 / 5000) * 5000;


    this.displayResult = {
      min,
      max
    }
    const hiddenInput = document.querySelector(this.config.hiddenInput);
    hiddenInput.value = `${this.displayResult.min},${this.displayResult.max}`;

  }
}

$(document).ready(function () {
  const body = document.querySelector("body");
  if (Array.from(body.classList).indexOf("simulation") >= 0) {
    new Core(config);
  }
})
